import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner TestiBack">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">TERMS OF USE</h2>
						<div className="red-border"> </div>
						<p>Terms of service for India's leading software development, mobile application development, web development and IT consulting company.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
